import $ from "jquery"

//  import Bootstrap 
require('bootstrap');
// #####################
// ### current INDEX ###
require("./2026/index")
